import ForgotCardFooter from './ForgotCardFooter';

export const FOOTER_DICTIONARY = { forgot: ForgotCardFooter };
